<script setup>
import { computed, ref } from 'vue'
import { useWindowSize } from '@vueuse/core';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router'
import { Dropdown,  Menu, } from 'ant-design-vue';
import config from "../config"
  const ADropdown = Dropdown;
  const AMenu = Menu;
  const AMenuItem = Menu.Item;

  const { width } = useWindowSize()
  let route = useRoute()
  let isIndexPage = computed(() => {
    return route.name === 'Index'
  })

  const goCreateAvatar = () => {
    // window.open(config.goCreateAvatarUrl);
    window.open(config.iamgeEditUrl);
  }

  const onClickDropdownFn = (item) => {
      console.log(`Click on item ${item.key}`);
      let key = item.key || 99;
      switch(key) {
        case '1':
          window.open(config.aiMindUrl);
          break;
        case '2':
          window.open(config.aiAgentUrl);
          break;
        case '3':
          window.open(config.colaAiUrl);
          break;
        case '4':
          goCreateAvatar();
          break;
        default:
          break;
      }
    }
</script>

<template>
  <a-dropdown v-if="!isIndexPage && width > 780" class="ml-2">
      <a class="ant-dropdown-link" @click.prevent>
        <span class="mune-item">AI辅助创作</span>
      </a>
      <template #overlay>
        <a-menu @click="onClickDropdownFn">
          <a-menu-item key="4">
            可乐改图
          </a-menu-item>
          <a-menu-item key="3">
            智能助手
          </a-menu-item>
          <a-menu-item key="1">
            思维导图
          </a-menu-item>
          <a-menu-item key="2">
            AI工作台
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
</template>

<style scoped>
:deep(.ant-dropdown-link) {
  height: 32px;
  line-height: 32px;
  @apply mr-6;
  font-size: 14px;
  font-family:  "PingFang SC";
}

.mune-item {
  font-weight: 600;
  font-size: 14px;
}
</style>
